import { render } from "./BackgroundIframe.vue?vue&type=template&id=c2bc7e1c&scoped=true&ts=true"
import script from "./BackgroundIframe.vue?vue&type=script&lang=ts"
export * from "./BackgroundIframe.vue?vue&type=script&lang=ts"

import "./BackgroundIframe.vue?vue&type=style&index=0&id=c2bc7e1c&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bc7e1c"]])

export default __exports__